module.exports = __webpack_public_path__ + "static/media/stepper-inactive-icon.42a7b222.svg";